import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Zap } from "lucide-react";
import CheckoutButton from "@/components/subscription/CheckoutButton";
import { getPriceId } from "@/config/stripe";

interface SellerUpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  featureName?: string;
}

const SellerUpgradeDialog = ({ open, onOpenChange, featureName }: SellerUpgradeDialogProps) => {
  const sellerPriceId = getPriceId("seller", "monthly");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-godyspo-gold/10 rounded-full flex items-center justify-center mb-4">
            <Crown className="h-6 w-6 text-godyspo-gold" />
          </div>
          <DialogTitle className="text-xl">
            Upgrade to Access {featureName || "Shark Plan Features"}
          </DialogTitle>
          <DialogDescription className="text-base">
            Your free trial has ended. Upgrade to continue listing deals and accessing buyers.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <h4 className="font-semibold text-godyspo-gold mb-2 flex items-center gap-2">
              <Zap className="h-4 w-4" />
              Shark Plan Features
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Unlimited property listings</li>
              <li>• Advanced buyer search and filtering</li>
              <li>• Direct buyer contact information</li>
              <li>• Real-time notifications and analytics</li>
              <li>• Priority customer support</li>
            </ul>
          </div>
          
          <div className="text-center">
            <p className="text-2xl font-bold text-godyspo-gold"><span className="text-lg font-medium text-muted-foreground line-through mr-2">$68</span>$34.99/month</p>
            <p className="text-sm text-muted-foreground">Cancel anytime</p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            onClick={() => {
              onOpenChange(false);
              window.location.href = '/seller/upgrade';
            }}
            className="w-full bg-godyspo-gold text-black hover:bg-godyspo-gold/90"
            size="lg"
          >
            View Upgrade Options
          </Button>
          
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            className="w-full"
          >
            Maybe Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SellerUpgradeDialog;